<template>
  <div class="vheader">
    <div class="ncuthead_01" style="padding: 0.25rem; text-align: left; " v-bind:style="{'background': headerImg }">
      <div class="head_linker">
        <a class="head_a" href="#"  @click.prevent="contactUs()">&nbsp;{{$t('message.Contacts_txt')}}&nbsp;</a> | <a class="head_a" href="https://www.ncut.edu.tw/" target="_blank">&nbsp;{{$t('message.NCUT_txt')}}&nbsp;</a>
      </div>
      <span class="locale-changer" style="position: absolute; top: 0.5rem; right: 13.5em;">
      </span>
      <div class="logo" v-show="!checkBG">
        <a href="#"><img src="@/assets/images/title1.png" style="height: 6rem;" alt="NCUT勤益校徵圖示" title="NCUT Logo" /></a>
      </div>
      <div class="head_info">
        <span style="background-color: rgba(33,99,33, 0.2);" v-if="user.isInit">
          <span>{{user.name}}，您好</span>&nbsp;&nbsp;<span class="md" v-if="false">{{user.loginTime | dateFormat}}登入</span>
        </span>
      </div>
      <div class="titlementbox">
        <div style="height: 100%; right: 1rem; text-align: left; margin-top: 1.5rem; margin-left: 6rem;"
          v-resize-text="{ratio:1.5, minFontSize: '26px', maxFontSize: '42px', delay: 200}"
          v-if="showTitle">
          {{setting.sysTitle[0].codeName}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResizeText from 'vue-resize-text'
import * as tools from '@/tool'
export default {
  name: 'vheader',
  props: [
    'pageInfo'
  ],
  directives: {
      ResizeText
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    },
    setting () {
      return this.$store.getters.getSetting
    },
    headerImg () {
      let url = '';
      if (this.checkBG) {
         url  = 'url(./WebApi/Common/ShowSystemDocByType/'.concat(this.$store.getters.getSysId).concat('/').concat(2).concat(')');
      } else  {
        url = '#f8e8c1';
      }
      return url
    },
    showTitle() {
      var ret = false;
      if (this.setting!=null) {
        ret = (this.setting.showTitle[0].codeName=='1');
      }
      return ret;
    },
    checkBG() {
      return (this.setting!=null && this.setting.headerFile != null && this.setting.headerFile[0]!= null && this.setting.headerFile[0].codeName.length>0);
    }
  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var ss = d.getMinutes()
      return year + '年' + month + '月' + day + '日' + hh + '時' + ss + '分'
    }
  },
  methods: {
    // setLang (newLang) {
    //   i18n.locale = newLang;
    //   localStorage.setItem('locale', newLang);
    // },
    contactUs: function() {
      this.$emit('toggle', -2, -2)
    },
    loginIn: function() {
      this.$emit('toggle', -3, -3)
    },
    toggle: function (appId, pageId) {
      //console.log('toggle call' + appId, pageId)
      this.$emit('toggle', appId, pageId)
    },
    handleSelect: function (key, keyPath) {
      //console.log(key, keyPath)
    },
    logout: function () {

      if ('S' == this.user.mode) {
        this.$store.dispatch('resetUser')
        this.$emit('getDefaultMenu', this.sysId, false)
        this.$router.push({ path: 'main' })
      } else {
        var user = {
          id1: this.$store.state.user.id,
          id2: '',
          id3: '',
          isLogin: false,
          sysId: this.sysId
        }
        var vm = this
        this.$http.put('./WebApi/Common/Authorized', user)
          .then((response) => {
            if (response.data != null) {
              console.log('logout' + user.id)
              vm.$store.dispatch('resetLogin')
              this.$emit('getDefaultMenu', vm.sysId, false)
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error);
          })
      }
    }
  },
  created () {
    //console.log('======created=====Header')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: contents;
}
.head_info {
  position: absolute;
  bottom: 0.35em;
  right: 1.75em;
  color: #ffffa7;
}
.head_a {
  color: white;
  text-decoration: none;
  font-size: 12px;
  font-family: verdana, 'trebuchet ms', sans-serif;
}
.head_linker {
  background-color: rgba(33,99,33, 0.2);
  position: absolute;
  top: 0.5rem;
  right: 1rem;
}
.ncuthead_01 {
  position: relative;
  height: 6.375rem;
  /* background: #fafafa url(Content/Images/greengrass0505.jpg) no-repeat; */
  background-position: 0px 0px;
}
.titlementbox {
    width: 100%;
    height: 2rem;
    left: 16rem;
    position: absolute;
    display: contents;
}
.menu_bar {
  background-color: #00bfff;
  line-height: 3em;
}
.div-container {
  display: table;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.sys-title-font {
  text-align: left;
  margin: 0.75rem 0 0;
  font-size: 2.25rem;
  font-weight: bolder;
  color: #161823;
  font-family: -apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}
/* check if the screen size is at least 500px */
@media (max-width: 500px) {
  .md {
    display: none;
  }
}
</style>
